import { Component } from "@angular/core";

@Component({
	selector: "stacked-card",
	templateUrl: "./stacked-cards.component.html",
	styleUrls: ["./stacked-cards.component.scss"]
})
export class StackedCardsComponent {}
